import { AmpPlugin } from '../amp-plugin';
import { TapForSound } from './component';
const TapForSoundPlugin = new AmpPlugin(TapForSound);
export { TapForSoundPlugin }